import { render, staticRenderFns } from "./Wishes.vue?vue&type=template&id=2cf748c3&scoped=true&"
import script from "./Wishes.vue?vue&type=script&lang=js&"
export * from "./Wishes.vue?vue&type=script&lang=js&"
import style0 from "./Wishes.vue?vue&type=style&index=0&id=2cf748c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf748c3",
  null
  
)

export default component.exports